import {useSelector} from 'react-redux';


import {configSelectors} from '../../Config';

import useGeoConfig from './useGeoConfig';


function useCountries() {

    // load to have it available
    useGeoConfig();

    return useSelector(configSelectors.getCountries) || [];
}


export default useCountries;
